// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import {
  // LIST
  ISetSelfAssessmentFormGetFormListDropdownAttrs,
} from 'interfaces/back-office/set-self-assessment-form/set-self-assessment-form-view.interface'

const useSetSelfAssessmentForm = () => {
  // Hook
  const {
    setSelfAssessmentForm: {
      setSelfAssessmentForm_isListLoading,
      setSelfAssessmentForm_dropdown,
      setSelfAssessmentForm_fetchDropdown: setSelfAssessmentFormFetchDropdown,
    },
  } = useStores()

  /**
   * @description Get form list dropdown
   *
   * @param {ISetSelfAssessmentFormGetFormListDropdownAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const setSelfAssessmentForm_fetchDropdown = useCallback(
    (payload: ISetSelfAssessmentFormGetFormListDropdownAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        setSelfAssessmentFormFetchDropdown({
          requestConfig: payload.requestConfig,
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    // eslint-disable-next-line
    [],
  )

  return {
    // LIST
    setSelfAssessmentForm_isListLoading,
    setSelfAssessmentForm_dropdown,
    setSelfAssessmentForm_fetchDropdown,
  }
}

export { useSetSelfAssessmentForm }
